import { apiSlice } from '@/redux/apiSlice';

export const stackAndShipApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createRequestItem: builder.mutation({
      query: (body) => ({
        url: `/stack-and-ship`,
        method: 'POST',
        body: body,
      }),
    }),
    getRequestItems: builder.query<any, { scope?: 'mine' | 'all' } | void>({
      query: (params) => {
        const scope = params?.scope;
        return {
          url: scope ? `/stack-and-ship?scope=${encodeURIComponent(scope)}` : `/stack-and-ship`,
          method: 'GET',
        };
      },
      providesTags: ['Project'],
    }),
    uploadProject: builder.mutation({
      query: (body) => ({
        url: `/offline/upload/${body.projectId}`,
        method: 'POST',
        body: { selectedSections: body.selectedStages, ...body },
      }),
    }),
    getRequestItemById: builder.query({
      query: (id) => ({
        url: `/stack-and-ship/${id}`,
        method: 'GET',
      }),
    }),
    updateRequestItem: builder.mutation({
      query: ({ data, id }) => ({
        url: `/stack-and-ship/update-request-item/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteRequestItem: builder.mutation({
      query: (id) => ({
        url: `/stack-and-ship/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Project'],
    }),
    getKnnData: builder.query({
      query: (data) => ({
        url: `/stack-and-ship/knn?data=${encodeURIComponent(JSON.stringify(data))}`,
        method: 'GET',
      }),
    }),
    saveChosenCases: builder.mutation({
      query: (data) => ({
        url: `/stack-and-ship/save-chosen-cases`,
        method: 'POST',
        body: data,
      }),
    }),
    updateChosenCases: builder.mutation({
      query: (data) => ({
        url: `/stack-and-ship/update-chosen-cases`,
        method: 'PUT',
        body: data,
      }),
    }),

    // updateNewChosenCases: builder.mutation({
    //   query: (data) => ({
    //     url: `/stack-and-ship/update-new-chosen-cases`,
    //     method: 'PUT',
    //     body: data,
    //   }),
    // }),
    getTempUrls: builder.query({
      query: (folderNames) => ({
        url: `/stack-and-ship/temp-urls/${folderNames}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useCreateRequestItemMutation,
  useGetRequestItemsQuery,
  useGetRequestItemByIdQuery,
  useUpdateRequestItemMutation,
  useDeleteRequestItemMutation,
  useGetKnnDataQuery,
  useSaveChosenCasesMutation,
  useGetTempUrlsQuery,
  useUpdateChosenCasesMutation,
  // useUpdateNewChosenCasesMutation,
} = stackAndShipApiSlice;
